//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import type {TemplateFooterComponent as FooterType} from '../../entities/multichat/whatsapp-api';

type Props = {
  component: FooterType,
};

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '11px',
    color: colors.grey900,
  },
}));

export default function TemplateFooterComponent({component}: Props) {
  const classes = useStyles();

  if (!component.text) return null;

  return <Typography className={classes.text}>{component.text}</Typography>;
}
